
<template>
  <div>
    
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-50"
      />
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid ref="grid" :service="service" route_name="natural_entities">
      <template v-slot:actions="actions">
        <feather-icon
          v-permission="`legal_entities.edit`"
          icon="EditIcon"
          class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
          v-if="!hide_edit"
          @click="actions.methods.edit(actions.data[actions.indextr].id)"
        />
        <feather-icon
          v-permission="`legal_entities.delete`"
          icon="Trash2Icon"
          class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
          v-if="!hide_delete"
          @click="confirmDestroy(actions.data[actions.indextr])"
        />
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import NaturalEntityService from '@/services/api/NaturalEntityService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$store.commit('naturalEntity/UPDATE_NATURAL_ENTITY', null)
      this.$router.push('/people/natural_entities/create')
    },
    confirmDestroy(natural_entity) {
      let message = 'Tem certeza que deseja excluir este registro?'
      
      const hasUser = !!natural_entity.user

      if (hasUser) {
        const userLabel = natural_entity.user

        message = `Usuário vinculado a essa pessoa. \nVocê deve excluir o usuário ${userLabel} antes de remover esse registro.`
      }

      this.$vs.dialog({
        type: hasUser ? 'alert' : 'confirm',
        color: 'warning',
        title: hasUser ? 'Exclusão não permitida!' : 'Atenção!',
        acceptText: hasUser ? 'OK' : 'Sim',
        cancelText: 'Não',
        text: message,
        accept: () => { if (!hasUser) { this.acceptDestroy(natural_entity) }},
      })
    },
    acceptDestroy(natural_entity) {
      this.service.destroy(natural_entity.id).then(
        (response) => {
          this.$vs.loading.close()
          this.notifySuccess(this.$vs, 'Operação realizada com sucesso.', 5000)
          this.$refs.grid.fetchGridData(this.$refs.grid.$data.model.current_page)
        },
        (error) => {
          this.$vs.loading.close()
        }
      )
    }
  },
  beforeMount() {
    this.service = NaturalEntityService.build(this.$vs)
  }
}
</script>